/**
 * Studio — Activity Handlers (read-only from registry).
 */

import { Loader2 } from "lucide-react";
import { AppShell } from "../../layouts/AppShell";
import { useActivityHandlers } from "../../../api/opsV2/hooks";

type StudioHandlersPageProps = {
  userName?: string;
  onBack?: () => void;
};

export function StudioHandlersPage({
  userName = "Utilisateur",
  onBack,
}: StudioHandlersPageProps) {
  const { data: handlers, loading, error, refetch } = useActivityHandlers();

  return (
    <AppShell
      userName={userName}
      topbar={
        <div className="flex items-center gap-4">
          {onBack && (
            <button type="button" onClick={onBack} className="text-sm text-muted hover:text-text">
              Studio
            </button>
          )}
          <span className="text-sm font-medium text-text">Handlers</span>
        </div>
      }
    >
      <div className="ds-container py-6">
        <h1 className="text-xl font-semibold text-text mb-2">Activity Handlers</h1>
        <p className="text-sm text-muted mb-4">
          Registre des types d’activité disponibles (runtime). Lecture seule.
        </p>

        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted py-8">
            <Loader2 className="h-4 w-4 animate-spin" />
            Chargement…
          </div>
        )}
        {error && (
          <div className="rounded-lg border border-destructive/50 bg-destructive/5 p-4 text-sm text-destructive">
            {error.message}
            <button type="button" onClick={() => refetch()} className="ml-2 underline">
              Réessayer
            </button>
          </div>
        )}
        {!loading && !error && (!handlers || handlers.length === 0) && (
          <p className="text-sm text-muted py-6">Aucun handler enregistré.</p>
        )}
        {!loading && !error && handlers && handlers.length > 0 && (
          <div className="rounded-md border border-border overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border bg-muted/30">
                  <th className="text-left p-3 font-medium text-text">Type</th>
                  <th className="text-left p-3 font-medium text-text w-20">Version</th>
                  <th className="text-left p-3 font-medium text-text">Description</th>
                </tr>
              </thead>
              <tbody>
                {handlers.map((h, i) => (
                  <tr key={`${h.activity_type}-${h.handler_version}-${i}`} className="border-b border-border/50 hover:bg-muted/20">
                    <td className="p-3 font-medium text-text">{h.activity_type}</td>
                    <td className="p-3 text-muted">v{h.handler_version}</td>
                    <td className="p-3 text-muted">{h.description || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AppShell>
  );
}
